import { IPropsWithChildren } from '@omaze/app';
import { ICON_COLOR, ICON_TYPE, OzIcon } from '@omaze/omaze-ui';
import React, { ReactElement } from 'react';
import { FacebookShareButton, TwitterShareButton } from 'react-share';

import { SocialShareButtonsAltText, SocialShareButtonsTestIds } from './SocialShareButtonsConstants';

function RoundedContainer (props: IPropsWithChildren): ReactElement {
    const { children }: IPropsWithChildren = props;

    return (
        <div className="w-4 h-4 bg-gray-900 rounded-full flex justify-center py-1">
            {children}
        </div>
    );
}

export function SocialShareButtons (): ReactElement {
    const shareUrl: string = document.location.toString();

    return (
        <div data-testid={SocialShareButtonsTestIds.HOST} className="flex mb-3 lg:mb-4">
            <FacebookShareButton
                url={shareUrl}
                data-testid={SocialShareButtonsTestIds.FACEBOOK_SHARE}
                className="mr-2"
            >
                <RoundedContainer>
                    <OzIcon
                        data-testid={SocialShareButtonsTestIds.FACEBOOK_ICON}
                        alt={SocialShareButtonsAltText.FACEBOOK_ICON}
                        type={ICON_TYPE.OZ_FACEBOOK} color={ICON_COLOR.LIGHT}
                    />
                </RoundedContainer>
            </FacebookShareButton>
            <TwitterShareButton
                url={shareUrl}
                data-testid={SocialShareButtonsTestIds.TWITTER_SHARE}
            >
                <RoundedContainer>
                    <OzIcon
                        data-testid={SocialShareButtonsTestIds.TWITTER_ICON}
                        alt={SocialShareButtonsAltText.TWITTER_ICON}
                        type={ICON_TYPE.OZ_TWITTER}
                        color={ICON_COLOR.LIGHT}
                    />
                </RoundedContainer>
            </TwitterShareButton>
        </div>
    );
}
